import type { IRunPlan, IRemoveViewCrate } from '../types';
import { writeDictionary } from '../services/loop';
import { writeJSON } from '../services/json';
import { RemoteView } from './remote_view';

/**
 * load a single crate into a frame to render one web component
 */
export class CrateRemoteView extends RemoteView {
  public runPlan: IRunPlan<IRemoveViewCrate>;

  async writeHead() {
    const runPlan = this.runPlan;
    const head = [...this._writeStandardHeader(runPlan)].join('\n');

    return head;
  }

  async writeBody() {
    const runPlan = this.runPlan;
    const remoteView = runPlan.remote_view;
    const component = remoteView.component.name ?? 'portal-no-render-component';
    const attributes = writeDictionary(
      remoteView.component.attributes ?? {},
      (value, key) => `${key.trim()}="${writeJSON(value)}"`
    );

    return `<${component} ${attributes}></${component}>`;
  }

  async writeIndex(runPlan: IRunPlan, head: string, body: string) {
    return `<!DOCTYPE html>
    <html lang="en">
      <head>${head}</head>
      <body>${body}</body>
    </html>`;
  }

  protected _computeStartupRemoteView<E extends HTMLElement>(computationalContext: E) {
    const runPlan = this.runPlan;
    const remoteView = runPlan.remote_view;
    const crateLoadCommands = (remoteView.crates ?? []).map(
      (crate) => `$ip.$loader.loadCrate('${crate.id}', '${crate.version}', ${crate.settings ?? '{}'})`
    );

    const properties = writeJSON(remoteView.component.properties ?? {});
    const component = remoteView.component.name ?? 'portal-no-render-component';
    const crateModules = crateLoadCommands.join('\n');

    return `
      ${crateModules}
      // add properties to the element
      //
      (function () {
        const props = ${properties} ?? {};
        const el = document.querySelector('${component}');
        if (!el) {
          return;
        }

        for (const k in props) {
          el[k] = props[k];
        }
      })();
    `;
  }
}
